import { LogOutWrapper } from '#app/features/authentication/components/LogOutWrapper.js';

export const Page = () => <LogOutWrapper />;
